'use strict';

var _ = require('lodash');
var availableModes = require('../config/referenceValueModes');
var ReferenceValueToggleService = function ReferenceValueToggleService(featureToggleService, userPreferencesService) {
  function isModeEnabled(mode) {
    return !mode.featureEnabled || featureToggleService.isEnabled(mode.featureEnabled);
  }
  function seasonAverageDisableForPS(mode) {
    if (mode.value === 'seasonalAverage' && featureToggleService.isEnabled('POOLED_SEASONALITY')) {
      return false;
    }
    return true;
  }
  function getAvailableModes() {
    return _.reduce(availableModes, function (result, mode) {
      if (isModeEnabled(mode) && seasonAverageDisableForPS(mode)) {
        result.push(_.pick(mode, ['value', 'label']));
      }
      return result;
    }, []);
  }
  function getDefaultMode() {
    return featureToggleService.isEnabled('REVENUE_OPTIMIZER') ? 'lastYear' : 'seasonalAverage';
  }
  function getModesWithSelection(availableModes, forcedSelection, defaultMode) {
    var selectionPreference = forcedSelection || userPreferencesService.getUserSettingComponent('defaultReference') || defaultMode;
    var result = {
      referenceValueModes: availableModes,
      referenceValueModesAvailable: false,
      selectedReference: undefined
    };
    var preferredMode = _.find(availableModes, {
      value: selectionPreference
    });
    var selectedMode = preferredMode ? preferredMode : availableModes[0];
    selectedMode.selected = true;
    result.referenceValueModesAvailable = availableModes && availableModes.length > 0;
    result.selectedReference = selectedMode.value;
    return result;
  }
  function getInitialReferenceValues(forcedSelection) {
    var referenceModes = getAvailableModes();
    var defaultMode = getDefaultMode();
    return getModesWithSelection(referenceModes, forcedSelection, defaultMode);
  }
  return {
    getInitialReferenceValues: getInitialReferenceValues
  };
};
ReferenceValueToggleService.$inject = ['FeatureToggleService', 'UserPreferencesService'];
module.exports = ReferenceValueToggleService;